export const formatCurrency = (value: number | null | undefined, decimals = 2): string => {
	if (value === undefined || value === null) return '-';
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals
	}).format(value);
};

export const formatPrice = (value: number | null | undefined): string => {
	if (value === undefined || value === null) return '-';
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumSignificantDigits: 1,
		maximumSignificantDigits: 5
	}).format(value);
};

export const formatNumber = (value: number | null | undefined, decimals = 2): string => {
	if (value === undefined || value === null) return '-';
	return new Intl.NumberFormat('en-US', {
		notation: 'compact',
		compactDisplay: 'short',
		minimumSignificantDigits: 1,
		maximumSignificantDigits: Math.max(decimals + 2, 3)
	}).format(value);
};

export const formatPercent = (value: number | null | undefined, decimals = 2): string => {
	if (value === undefined || value === null) return '-';
	return new Intl.NumberFormat('en-US', {
		style: 'percent',
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		signDisplay: 'exceptZero'
	}).format(value);
};

export const formatScore = (value: number | null | undefined, decimals = 4): string => {
	if (value === undefined || value === null) return '-';
	const sign = value >= 0 ? '+' : '';
	return `${sign}${value.toFixed(decimals)}`;
};

// Fixed-decimal format (no compact/significant-digit rounding) for values where
// precise comparison matters, e.g. thresholds and scores near a decision boundary.
export const formatFixed = (value: number | null | undefined, decimals = 4): string => {
	if (value === undefined || value === null) return '-';
	return value.toFixed(decimals);
};

// Format PnL values with compact notation for large numbers (> 1000)
export const formatPnl = (value: number | null | undefined): string => {
	if (value === undefined || value === null) return '-';
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		notation: 'compact',
		compactDisplay: 'short',
		maximumSignificantDigits: 3
	}).format(value);
};
